/** Base path of the department tree. */
export const DEPARTMENT_BASE_PATH = '/departments';

const createDepartmentPath = (
    departmentId: string,
    suffix = '' as string,
): string => `${DEPARTMENT_BASE_PATH}/${departmentId}${suffix}`;

export const DEPARTMENT_PATHS = {
    /** Department root — the department dashboard. */
    root: (departmentId: string): string => createDepartmentPath(departmentId),

    // Staffing plans domain (bemanningsplaner)
    /** Staffing plan list. */
    tasks: (departmentId: string): string =>
        createDepartmentPath(departmentId, '/tasks'),
    /** Staffing plan detail (setup, staffing, overview). */
    taskDetail: (departmentId: string, taskId: string): string =>
        createDepartmentPath(departmentId, `/tasks/${taskId}`),
    /** Staffing plan result (rotation) — redirects to its default tab. */
    taskResult: (departmentId: string, taskId: string): string =>
        createDepartmentPath(departmentId, `/tasks/${taskId}/result`),
    /** Staffing plan result tab (overview, shift-schedule, cost, …). */
    taskResultTab: (
        departmentId: string,
        taskId: string,
        tab: string,
    ): string =>
        createDepartmentPath(departmentId, `/tasks/${taskId}/result/${tab}`),

    // Department settings domain
    /** Department settings tabs (general, positions, shift-codes, …). */
    settings: (departmentId: string): string =>
        createDepartmentPath(departmentId, '/settings'),
} as const;
